var exports = {
  "k": "container__6OMv8Y",
};

module.exports = exports;
